export const concernTitles = [
  'No concern',
  'Yes, mildly',
  'Yes, moderately',
  'Yes, significantly',
];
